export default "__VITE_ASSET__ClhwnjgU__"